import { userPic } from '../../../assets/images';
import { TItemType } from '../PlayerListItem';
import { isAward } from './isAward';
import { isEventEnrollment } from './isEventEnrollment';
import { isPlayer } from './isPlayer';

export const getUserImage = (item: TItemType) => {
  if (isPlayer(item)) {
    return item.profile.image;
  }

  if (isEventEnrollment(item)) {
    return item.user.profile.image;
  }

  if (isAward(item)) {
    const firstAward = item.awards[0];

    return firstAward ? firstAward.userImage : userPic;
  }
};
